import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { IStory, IStoryContent } from '@opengov/stories-shared/types';
import React, { useState } from 'react';
import { IUpdateStoryContentProps } from '../../../../../types/storyViewTypes';
import { useToast } from '../../../Toast/context/useToast.context';
import { DeleteConfirmationModal } from '../../../CommonComponents/DeleteConfirmationModal/DeleteConfirmationModal';
import { clearTableMarkupFromStoryContent } from './EditCustomSpreadsheetMediaModal.utils';
import locale from '../customReports-locale.json';
import { styles } from './DeleteSpreadsheetMarkupModal.styles';

type Props = {
  story: IStory;
  storyContent: IStoryContent;
  mediaIndex: number;
  updateStoryContent: (storyContent: IStoryContent) => void;
  updateStoryContentDB: (props: IUpdateStoryContentProps) => void;
  onClose: () => void;
};

export function DeleteSpreadsheetMarkupModal({
  story,
  storyContent,
  mediaIndex,
  updateStoryContent,
  updateStoryContentDB,
  onClose
}: Props) {
  const { toggleToast } = useToast();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteTableMarkup = async () => {
    try {
      setIsDeleting(true);
      // Remove table markup from storyContent
      const newStoryContent = clearTableMarkupFromStoryContent({ storyContent, mediaIndex });
      updateStoryContent(newStoryContent);
      updateStoryContentDB({ story: story, isTemplate: false, storyContent: newStoryContent });
    } catch (error) {
      console.error(error);
      toggleToast({
        title: locale.errors.somethingWentWrong,
        body: locale.errors.unableToDeleteSpreadsheetTable,
        severity: 'error'
      });
    } finally {
      setIsDeleting(false);
      onClose();
    }
  };

  return (
    <DeleteConfirmationModal
      title={locale.deleteSpreadsheetMarkupModal.deleteTable}
      message={
        <Box sx={styles.message}>
          <Typography variant="body1">{locale.deleteSpreadsheetMarkupModal.editingIsDisabled}</Typography>
          <Typography variant="body1">{locale.deleteSpreadsheetMarkupModal.pleaseConfirm}</Typography>
        </Box>
      }
      isDeleting={isDeleting}
      onClose={onClose}
      onDelete={handleDeleteTableMarkup}
      dataTest="delete-spreadsheet-table-confirmation-modal"
    />
  );
}
